import { Outlet } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../components/header';
import Footer from '../components/footer';

const AuthLayout = ({ user }: { user: any }) => {
  return (
    <>
      <Header />

      <div className="min-h-[calc(100dvh-110px)] py-2.5 pb-5">
        <div className="max-w-[96%] mx-auto">
          <Outlet />
        </div>
      </div>
      
      <Footer />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user?.user || null,
});

export default connect(mapStateToProps)(AuthLayout);